var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertCancelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.5,
    height: 19.5,
    viewBox: "0 0 19.5 19.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "x-square_1_",
    "data-name": "x-square (1)",
    transform: "translate(-2.25 -2.25)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_764",
    "data-name": "Rectangle 764",
    width: 18,
    height: 18,
    rx: 2,
    transform: "translate(3 3)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_119",
    "data-name": "Line 119",
    x2: 6,
    y2: 6,
    transform: "translate(9 9)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_120",
    "data-name": "Line 120",
    x1: 6,
    y2: 6,
    transform: "translate(9 9)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertCancelIcon);
export default __webpack_public_path__ + "static/media/alert-cancel-icon.81938e3c820def68844148bb5a8e9736.svg";
export { ForwardRef as ReactComponent };